import styled from 'styled-components';
import imageHelper from '@utils/imageHelper';
import BackGroundImage from './BackgroundImage';

const Container = styled.div`
  margin-top: 80px;
  grid-column: span 24;
  position: relative;
  @media (max-width: 70.95em) {
    margin-top: 76px;
  }
`;

const MissionGroup = styled.div`
  grid-column: span 13;
  margin-top: 64px;
  margin-bottom: 80px;
  @media (max-width: 70.95em) {
    grid-column: span 12;
  }
  @media (max-width: 70.95em) {
    grid-column: span 24;
    margin-bottom: 42px;
    margin-top: 32px;
  }
`;

const Block = styled.div`
  grid-column: span 24;
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  @media (max-width: 70.95em) {
    display: flex;
    flex-direction: column;
    row-gap: 0;
    column-gap: 0;
  }
`;

const Mission = styled.span`
  font-weight: bold;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 2px;
  color: #08bd80;
  @media (max-width: 70.95em) {
    display: block;
    font-size: 12px;
    text-align: center;
  }
`;

const Description = styled.h2`
  font-weight: bold;
  font-size: 40px;
  line-height: 120%;
  color: #3c4852;
  margin-top: 16px;
  @media (max-width: 70.95em) {
    font-size: 24px;
    text-align: center;
  }
  @media (max-width: 47.95em) {
    padding: 0 16px;
  }
`;

const CardHolder = styled.div`
  grid-column: 2/12;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  @media (max-width: 70.95em) {
    grid-column: span 24;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 40px;
    padding: 0 16px;
  }
`;

const Card = styled.div`
  background: #ffffff;
  box-shadow: 0px 16px 32px rgba(221, 230, 237, 0.4);
  border-radius: 8px;
  width: 224px;
  height: 131px;
  padding: 20px 24px;
  @media (max-width: 70.95em) {
    width: auto;
    box-shadow: none;
    padding: 0px;
    flex-grow: 2;
  }
  @media (max-width: 70.95em) {
    background: transparent;
    height: 80px;
  }
`;

const Text = styled.span`
  font-weight: bold;
  font-size: 48px;
  line-height: 120%;
  color: ${({ $color }) => $color};
  @media (max-width: 70.95em) {
    font-size: 40px;
    text-align: center;
    display: block;
  }
`;

const SubText = styled.span`
  font-weight: 600;
  font-size: 20px;
  line-height: 150%;
  color: #627984;
  display: block;
  margin-top: 4px;
  @media (max-width: 70.95em) {
    font-size: 16px;
    text-align: center;
    color: #7b8ab5;
    font-weight: 400;
    margin-top: 8px;
  }
`;

const Image = styled.picture`
  grid-column: 13/24;
  @media (max-width: 70.95em) {
    grid-column: span 12;
    margin-top: 56px;
    padding: 0 16px;
  }
`;

const Src = styled.img`
  height: 278px;
  width: 560px;
  object-fit: contain;
  @media (max-width: 70.95em) {
    width: 100%;
    height: auto;
  }
`;

const Flex = styled.div`
  display: flex;
  justify-content: center;
`;

const Space = styled.span`
  @media (max-width: 47.95em) {
    display: none;
  }
`;

const infos = [
  { text: '50M', color: '#08BD80', subText: 'Active Learners' },
  { text: '1000', color: '#2D81F7', subText: 'Top Educators' },
  { text: '1B', color: '#FFAD3B', subText: 'Minutes Watched' },
  { text: '2000', color: '#EB5757', subText: 'Daily live Classes' }
];

const MissionBlock = () => {
  return (
    <Container>
      <BackGroundImage src={imageHelper.getImage('about/quote.png')} />
      <Block>
        <MissionGroup>
          <Mission>OUR MISSION & IMPACT</Mission>
          <Description>
            Democratise access to high quality education
          </Description>
        </MissionGroup>
        <CardHolder>
          {infos.map((info) => (
            <Card key={info.text}>
              <Flex>
                <Text $color={info.color}>{info.text}</Text>
                <Space>&nbsp;</Space>
                <Text $color={info.color}>+</Text>
              </Flex>
              <SubText>{info.subText}</SubText>
            </Card>
          ))}
        </CardHolder>
        <Image>
          <source srcSet={imageHelper.getImage('about/device_mashup.png')} />
          <Src
            src={imageHelper.getImage('about/device_mashup.png')}
            alt="unacademy"
          />
        </Image>
      </Block>
    </Container>
  );
};

export default MissionBlock;
